export default {
  contractActivity: {
    contractActivity: {
      title: ({ plural }) => plural(["Activity", "Activities"]),
      type: {
        professional: "Company",
        pedagogic: "Training",
      },
      tabs: {
        description: "Description",
        document: "Attachments",
      },
      status: {
        complete: "Complete",
        to_complete: "To complete",
      },
      context: "Context",
      description: "Tasks completed",
      difficulties_encountered: "Difficulties & solutions",
      results_obtained: "Results obtained",
      analysis_and_learning: "Analysis & learning",
      tools: "Tools & technologies",
      skills: "Related skills",
      autonomy_complexity: "Autonomy & complexity",
      missions: "Related missions",
      no_activities: "No activity is defined on this contract.",
      no_activities_filtered: "No activity matches the selected filter.",
      relatedSkills: {
        launch_analysis: "Run analysis",
        relaunch_analysis: "Re-run analysis",
        badge_default: "AI skills analysis",
        badge_with_date: ({ named }) => `Reference ${named("code")} — Analysis performed on ${named("date")}`,
        badge_no_date: ({ named }) => `Reference ${named("code")}`,
        no_activity_id: "Save the activity first to access the skills.",
        no_analysis: "Click « Run analysis » to identify the skills mobilised in this activity.",
        ia_disclaimer:
          "<strong>AI suggests skills, it does not validate them.</strong><br>Your apprentice master will validate them by certifying the activity.",
        analysing: "Analysis in progress, please wait…",
        ai_analysis: "AI analysis of the match between the activity and the skills block",
        summary_title: "AI analysis of the match between the activity and the skills",
        validated: "Validated",
        to_validate: "To validate",
        validate_all_proposals: "Validate the activity/skills relationship",
        add_block_picker_title: "Manually add skills blocks",
        add_block_confirm: "Add selected blocks",
        selected_skills_count: ({ named }) => `${named("count")} skill${named("count") <= 1 ? "" : "s"} selected`,
        collapsed_selected_skills_heading: "Selected skills",
        skill_status_selected: "Selected skill",
        skill_status_validated: "Validated skill",
      },
      annexes: {
        count: ({ named }) => `${named("count")} attachment${named("count") === 1 ? "" : "s"} linked to this activity`,
        technical_documents: "Technical documents",
        screenshots_photos: "Screenshots & photos",
        empty: "No attachment linked to this activity.",
      },
    },
    import: {
      button: "Import a report",
      confirm_title: "Drop your activity report",
      confirm_text:
        "The AI reads your document, splits it into distinct activities and pre-fills the structured fields. It organises your content, it does not invent any.",
      dropzone_hint: "PDF only",
      launch: "Start the analysis",
      validation_notice: "You will review and correct each activity before anything is saved.",
      loading_title: "Analysis in progress",
      step_reading_title: "Reading the document",
      step_reading_subtitle: "Extracting the text and structure",
      step_sections_title: "Splitting into sections",
      step_sections_subtitle: "Headings, thematic breaks",
      step_detection_title: "Detecting activities",
      step_detection_subtitle: "Action verbs — what the apprentice actually did",
      step_extraction_title: "Extracting information",
      step_extraction_subtitle: "Missions, periods, tasks, tools, sources",
      completed: "Analysis completed",
      error_title: "The analysis could not be completed",
      failed: "The report analysis failed. Please run it again.",
      retry: "Run the analysis again",
      result_title: "Validation",
      result_empty: "No activity could be detected in this report.",
      result_count: ({ plural, named }) =>
        plural([`${named("count")} activity detected`, `${named("count")} activities detected`]),
      result_sentence: "We identified {performed} and {observed}.",
      performed_count: ({ plural, named }) =>
        plural([`${named("count")} performed activity`, `${named("count")} performed activities`]),
      observed_count: ({ plural, named }) =>
        plural([`${named("count")} observed activity`, `${named("count")} observed activities`]),
      ai_summary_title: "What the AI found",
      review_notice:
        "Check the information extracted for each activity. You will be able to correct and complete it at any time after validation.",
      counter_activities: "Activities",
      counter_excluded: "Excluded sections",
      activities_list: "Activities detected in the report",
      ai_comment_title: "AI comment",
      status_to_check: "To review",
      status_validated: "Validated",
      not_specified: "Not specified in the report",
      to_complete: "To be completed after validation",
      level_not_specified: "Not specified",
      no_mission: "No mission linked yet",
      validate: "Validate this activity",
      validate_label: ({ named }) => `Validate the activity “${named("name")}”`,
      unvalidate: "Cancel the validation of this activity",
      unvalidate_label: ({ named }) => `Cancel the validation of the activity “${named("name")}”`,
      announcement_validated: ({ named }) =>
        `Activity "${named("name")}" validated. ${named("count")} validated activity(ies).`,
      announcement_unvalidated: ({ named }) =>
        `Activity "${named("name")}" not validated. ${named("count")} validated activity(ies).`,
      publish: ({ plural, named }) =>
        plural([`Create ${named("count")} validated activity`, `Create ${named("count")} validated activities`]),
      publish_success: ({ plural, named }) =>
        plural([
          `${named("count")} activity imported from the report and added to the logbook`,
          `${named("count")} activities imported from the report and added to the logbook`,
        ]),
      badge_ia: "AI-imported",
    },
  },
};
